import React from "react";
import "./MessageRenderer.css";
import {
  Image,
  Video,
  AudioTemp,
  DocumentCustom,
  Contact,
  MultiChoice,
  Location,
} from "../Message Components";
import { convertTimeIntoHourMin, formatMessage, getRole } from "../utils/generic";
import CarouselMsg from "../Message Components/CarouselMsg";
import CardMsg from "../Message Components/CardMsg";
import { MarkdownRenderer } from "./MarkdownRender";

function MessageRenderer({ message, sent, translate }) {

  const toTitleCaseWithSpaces = (str) => {
    return str
      .replace(/([a-z])([A-Z])/g, "$1 $2") // Add space before uppercase letters
      .replace(/(^|\s)\S/g, (group) => group.toUpperCase()); // Capitalize the first letter of each word
  };

  switch (message.type) {
    case "card":
      return (
        // <div className="typography__wrapper">
        //   <h4>Card Design</h4>
        //   {/* "content": {
        //             "card": {
        //                 "choices": [
        //                     {
        //                         "id": "81329a2b-3f03-4cb6-b92c-7f54767e39e8",
        //                         "url": "https://streamspace.ai/"
        //                     }
        //                 ],
        //                 "description": "Visit Our Website URL Threw",
        //                 "link": "",
        //                 "media": {
        //                     "link": "https://www.shutterstock.com/shutterstock/videos/1057665724/preview/stock-footage-a-seconds-countdown-introduction-with-beautiful-slick-graphics.mp4",
        //                     "type": "video"
        //                 },
        //                 "mediaOptionSelected": "insert_url",
        //                 "title": "Streamspace"
        //             }
        //         }, */}
        // </div>
        <div
          className={`message-body-item__inner message-body-item__${getRole(
            message
          )}-bubble`}
          style={{ maxWidth: "100%" }}
        >
          <CardMsg message={message} />
          <div className="message-info-td">
            <span className="message-time">
              {convertTimeIntoHourMin(message.timeStamp)}
            </span>
            {sent && (
              <span className="material-symbols-outlined message-deliver">
                check
              </span>
            )}
          </div>
        </div>
      );
    // break;
    case "location":
      return (
        <div
          className={`message-body-item__inner message-body-item__${getRole(
            message
          )}-bubble`}
          style={{ maxWidth: "100%" }}
        >
          <Location message={message} />
          <div className="message-info-td">
            <span className="message-time">
              {convertTimeIntoHourMin(message.timeStamp)}
            </span>
            {sent && (
              <span className="material-symbols-outlined message-deliver">
                check
              </span>
            )}
          </div>
        </div>
      );
    // break;
    case "text":
      return (
        <div
          className={`message-body-item__inner message-body-item__${getRole(
            message
          )}-bubble`}
        >
          <p className="msg" style={{ whiteSpace: "pre-wrap", margin: "0px" }}>
            {/* {message.content.text.trim()} */}
            {/* <div dangerouslySetInnerHTML={{ __html: formatMessage(message.content.text) }} /> */}
            <MarkdownRenderer content={ message.content.text } />
          </p>
          {translate ? (
            <div className="message-translate">
              {/* <span>Translated</span> */}
              <div className="d-flex align-items-center mt-1">
                <span class="material-symbols-outlined mr-2">translate</span>
                <span>Translated</span>
              </div>
              <p
                className="msg"
                style={{ whiteSpace: "pre-wrap", margin: "0px" }}
              >
                {translate ? translate : null}
              </p>
            </div>
          ) : (
            ""
          )}

          <div className="message-info-td">
            <span className="message-time">
              {convertTimeIntoHourMin(message.timeStamp)}
            </span>
            {sent && (
              <span className="material-symbols-outlined message-deliver">
                check
              </span>
            )}
          </div>
        </div>
      );
    // break;
    case "multiChoice":
      return (
        <div
          className={`message-body-item__inner message-body-item__${getRole(
            message
          )}-bubble`}
        // style={{ maxWidth: "100%" }}
        >
          <MultiChoice message={message} />
          <div className="message-info-td">
            <span className="message-time">
              {convertTimeIntoHourMin(message.timeStamp)}
            </span>
            {sent && (
              <span className="material-symbols-outlined message-deliver">
                check
              </span>
            )}
          </div>
        </div>
      );
    case "image":
      return (
        <div
          className={`message-body-item__inner message-body-item__${getRole(
            message
          )}-bubble`}
          style={{ maxWidth: "100%" }}
        >
          <Image message={message} />
          <div className="message-info-td">
            <span className="message-time">
              {convertTimeIntoHourMin(message.timeStamp)}
            </span>
            {sent && (
              <span className="material-symbols-outlined message-deliver">
                check
              </span>
            )}
          </div>
        </div>
      );
    // break;
    case "video":
      return (
        <div
          className={`message-body-item__inner message-body-item__${getRole(
            message
          )}-bubble`}
        >
          <Video message={message} />
          <div className="message-info-td">
            <span className="message-time">
              {convertTimeIntoHourMin(message.timeStamp)}
            </span>
            {sent && (
              <span className="material-symbols-outlined message-deliver">
                check
              </span>
            )}
          </div>
        </div>
      );
    // break;
    case "document":
      return (
        <div
          className={`message-body-item__inner message-body-item__${getRole(
            message
          )}-bubble`}
        >
          <DocumentCustom message={message} />
          <div className="message-info-td">
            <span className="message-time">
              {convertTimeIntoHourMin(message.timeStamp)}
            </span>
            {sent && (
              <span className="material-symbols-outlined message-deliver">
                check
              </span>
            )}
          </div>
        </div>
      );
    // break;
    case "audio":
      return (
        <div
          className={`message-body-item__inner message-body-item__${getRole(
            message
          )}-bubble`}
        >
          {" "}
          <AudioTemp message={message} />
          <div className="message-info-td">
            <span className="message-time">
              {convertTimeIntoHourMin(message.timeStamp)}
            </span>
            {sent && (
              <span className="material-symbols-outlined message-deliver">
                check
              </span>
            )}
          </div>
        </div>
      );
    // break;
    case "contacts":
      return (
        <div
          className={`message-body-item__inner message-body-item__${getRole(
            message
          )}-bubble`}
          style={{ maxWidth: "100%" }}
        >
          {" "}
          <Contact message={message} />
          <div className="message-info-td">
            <span className="message-time">
              {convertTimeIntoHourMin(message.timeStamp)}
            </span>
            {sent && (
              <span className="material-symbols-outlined message-deliver">
                check
              </span>
            )}
          </div>
        </div>
      );
    // break;
    case "carousel":
      return (
        <div
          className={`message-body-item__inner message-body-item__${getRole(
            message
          )}-bubble`}
          style={{ maxWidth: "100%" }}
        >
          <CarouselMsg message={message} />
          <div className="message-info-td">
            <span className="message-time">
              {convertTimeIntoHourMin(message.timeStamp)}
            </span>
            {sent && (
              <span className="material-symbols-outlined message-deliver">
                check
              </span>
            )}
          </div>
        </div>
      );
    // break;
    case "privateText":
      return (
        <div
          className={`message-body-item__inner private-note message-body-item__${getRole(
            message
          )}-bubble`} style={{ background: '#fef2a4' }}
        >
          <p className="msg" style={{ whiteSpace: "pre-wrap", margin: "0px", color: '#000' }}>
            {/* {message.content.text} */}
            <div dangerouslySetInnerHTML={{ __html: formatMessage(message.content.text) }} />
          </p>
          <div className="message-info-td">
            <span className="message-time">
              {convertTimeIntoHourMin(message.timeStamp)}
            </span>
            <span className="material-symbols-outlined message-deliver">
              lock
            </span>
          </div>
        </div >
      );
    // break;
    case "prechat":
      return (
        <div
          className={`message-body-item__inner message-body-item__${getRole(
            message
          )}-bubble`}
        >
          <p className="msg" style={{ whiteSpace: "pre-wrap", margin: "0px" }}>
            <span style={{ fontWeight: '700' }}>User Details</span>
            <hr style={{ margin: '3px -12px', borderBottom: '1px solid #E8E8E8' }} />
            {message && message.content && message.content.prechat && message.content.prechat.userInfo && typeof message.content.prechat.userInfo === "object"
              ? Object.entries(message.content.prechat.userInfo).map(([key, value]) => (
                <tr key={key}>
                  <td className="long-value-row detail-key">{toTitleCaseWithSpaces(key)} </td>
                  <td className="detail-value pl-3" style={{ wordBreak: 'break-word' }}>{value}</td>
                </tr>
              )) : ""}
            {/* {message.content.prechat ? summary.entitiesObject && typeof summary.entitiesObject === "object"
              ? Object.entries(summary.entitiesObject).map(([key, value]) => (
                <tr key={key}>
                  <td className="long-value-row detail-key">{key}:</td>
                  <td className="detail-value">{value}</td>
                </tr>
              ))
              : null} */}
          </p>
          <div className="message-info-td">
            <span className="message-time">
              {convertTimeIntoHourMin(message.timeStamp)}
            </span>
            {sent && (
              <span className="material-symbols-outlined message-deliver">
                check
              </span>
            )}
          </div>
        </div>
      );
    // break;
    default:
      return <div>
        {/* {
        `Need to Update UI for ${message.type}`} */}
      </div>;
  }
  // TODO remove after proper testing
  // return <div>{`Need to Update UI for ${message.type}`}</div>;
  // return <div></div>;
}

export default MessageRenderer;



// WEBPACK FOOTER //
// src/modules/screens/chatscreen/components/MessageRenderer/MessageRenderer.js